import React from "react";
import { ReactSession } from 'react-client-session';
import { Navigate } from "react-router-dom";
import Basic401 from "../Components/Pages/Error/Basic401";
import Basic503 from "../Components/Pages/Error/Basic503";
import { getLocalRoutes,getLocalSubmenus,getLocalAccessPermisions } from "./TokenServices";

/**
 * function that will provide the permitted menus
 * @returns Array()
 */
export const getPermittedMenuList = ()=>{
    return getLocalRoutes();
}

/**
 * function that will provide all the permissions
 * @returns Array()
 */
export const getPermissionList = ()=>{
    return getLocalAccessPermisions();
}

/**
 * 
 * @param {String} action - Action type to check
 * @returns 
 */
export const checkPermision =  (action)=>{
    let permisions = getLocalAccessPermisions();
    if(permisions){
        return permisions.filter((item)=> item?.action === action)[0];
    }else{
        return undefined;
    }
}


/**
 * Use to protect the protected routes, unless user logged and permitted to access.
 * @param {*} param
 * @returns 
 */
export const ProtectedRoute = ({isSignedIn,children,route})=>{
    let sessionRoutes = getLocalSubmenus();

    if(!isSignedIn) {
       return <Navigate to="/" replace/>
    }else{
        if(sessionRoutes?.filter((item)=> item?.s_route?.split(".").join("") === route )[0] !== undefined ){
            return children;
        }else{
            return <Basic503/>
        }
        
    }
}

/**
 * Method used to check the if logged user has permitted to access the services
 * @param {String} route - Route name        
 * @returns 
 */
export const HasPermittedRoute = (route)=>{
    let sessionRoutes = getLocalSubmenus();

    if(sessionRoutes?.filter((item)=> item?.s_route?.split(".").join("") === route )[0] !== undefined ){
        return true;
    }else{
        return false;
    }

}

/**
 * Function that will redirect user to assigned screen
 * @param {JSON} param LoggedUserProfile
 * @returns location
 */
export const RouteAuth = ({LoggedUserProfile})=>{
    // return <Navigate to={LoggedUserProfile?.baseroute} />
    return <Navigate to='/dashboard' />
}
